export enum DeviceType {
  MOBILE_SCANNER = 0,
  BLE_GATEWAY = 1,
  FIXED_RFID_READER = 2,
}

export interface DeviceLocationDTO {
  id: number;
  name: string;
  code: string;
}

export interface DeviceReadDTO {
  id: number;
  code: string;
  name: string;
  brand: string;
  type: string;
  serialNumber: string;
  lastEventReceivedAt?: Date;
  deviceType: DeviceType;
  identifier?: string;
  locationId?: number;
  location?: DeviceLocationDTO;
  moveTagsToLocationTimeMinutes?: number;
  moveTagsLocationId?: number;
  moveTagsLocation?: DeviceLocationDTO;
  maxTimeNotSeenMinutes?: number;
  alertEmails?: string[];
  offlineTimestamp?: Date;
  onlineSince?: Date;
}
export interface DeviceUpdateDTO {
  name: string;
  code: string;
  brand?: string | null;
  type?: string | null;
  serialNumber?: string | null;
  deviceType: DeviceType;
  identifier?: string | null;
  locationId?: number | null;
  moveTagsToLocationTimeMinutes?: number | null;
  moveTagsLocationId?: number | null;
  maxTimeNotSeenMinutes?: number | null;
  alertEmails?: string[] | null;
}
export interface DeviceCreateDTO {
  name: string;
  code: string;
  brand?: string | null;
  type?: string | null;
  serialNumber?: string | null;
  deviceType: DeviceType;
  identifier?: string | null;
  locationId?: number | null;
  moveTagsToLocationTimeMinutes?: number | null;
  moveTagsLocationId?: number | null;
  maxTimeNotSeenMinutes?: number | null;
  alertEmails?: string[] | null;
}
